(function () {
  "use strict";
  if (window.SR_WA_GATE) return;

  var CLIENT = "ablink.sg";
  var EP = "https://leads.rumah.live";
  var BRAND = "ABLINK.SG";
  var PRIVACY_URL = "/pages/privacy-policy";
  var WA_RE = /wa\.me\/|api\.whatsapp\.com|web\.whatsapp\.com|whatsapp:\/\/|whatsapp\.com\/send/i;
  var DEBUG = /[?&]sr_gate_debug=1/.test(location.search);

  var API = { version: "1.2.0", client: CLIENT, sent: [], events: [] };
  window.SR_WA_GATE = API;

  function log() { if (DEBUG && window.console) console.log.apply(console, ["[sr-gate]"].concat([].slice.call(arguments))); }
  function trim(s) { return String(s == null ? "" : s).replace(/^\s+|\s+$/g, ""); }
  function esc(s) {
    return String(s == null ? "" : s).replace(/[&<>"']/g, function (c) {
      return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c];
    });
  }
  function store(key, val) {
    try {
      if (val === undefined) return JSON.parse(localStorage.getItem(key) || "null");
      localStorage.setItem(key, JSON.stringify(val));
    } catch (e) {}
    return null;
  }

  function visitorId() {
    var v = null;
    try { v = localStorage.getItem("sr_vid"); } catch (e) {}
    if (!v) {
      v = "v" + Math.random().toString(36).slice(2, 10) + Date.now().toString(36);
      try { localStorage.setItem("sr_vid", v); } catch (e) {}
    }
    return v;
  }
  var VISITOR = visitorId();

  function firstTouch() {
    var ft = store("abl_ft");
    if (ft && ft.landing_url) return { p: ft.landing_url, r: ft.landing_referrer || "", t: ft.ts || "" };
    var mine = store("__sr_ft_" + CLIENT);
    if (mine && mine.p) return mine;
    return { p: location.href, r: document.referrer || "", t: "" };
  }
  function adClickId() {
    try { return localStorage.getItem("__sr_g_" + CLIENT) || ""; } catch (e) { return ""; }
  }

  function beacon(path, payload) {
    try {
      var body = JSON.stringify(payload);
      if (navigator.sendBeacon && navigator.sendBeacon(EP + path, new Blob([body], { type: "text/plain" }))) return;
      fetch(EP + path, { method: "POST", headers: { "Content-Type": "text/plain" }, body: body, keepalive: true, mode: "no-cors" });
    } catch (e) {}
  }

  var SERVICES = [
    [/new-commercial-vehicles|\/pages\/new-vehicles|vehicle-detail/, "New vehicles"],
    [/car-marketplace/, "Used vehicles"],
    [/lease-commercial-vehicle/, "Leasing"],
    [/coe-renewal/, "COE renewal loan"],
    [/motor-insurance/, "Motor insurance"],
    [/sell-vehicle/, "Sell your vehicle"],
    [/electric-van/, "Electric vans"],
    [/passenger-vans/, "Passenger vans"],
    [/choosing-the-right-vehicle/, "Vehicle advice"],
    [/\/pages\/contact/, "Contact"],
    [/\/blogs\//, "Articles"],
    [/^\/?$/, "Home"]
  ];
  function serviceOf(path) {
    path = String(path || location.pathname);
    for (var i = 0; i < SERVICES.length; i++) if (SERVICES[i][0].test(path)) return SERVICES[i][1];
    return "";
  }

  var TOPICS = ["New commercial vehicle", "Used commercial vehicle", "Lease a vehicle", "COE renewal loan",
    "Motor insurance", "Sell my vehicle", "Something else"];
  var TOPIC_BY_SERVICE = {
    "New vehicles": "New commercial vehicle", "Electric vans": "New commercial vehicle", "Passenger vans": "New commercial vehicle",
    "Used vehicles": "Used commercial vehicle", "Leasing": "Lease a vehicle", "COE renewal loan": "COE renewal loan",
    "Motor insurance": "Motor insurance", "Sell your vehicle": "Sell my vehicle"
  };

  var queue = [];
  var flushTimer = null;
  function interest(ev) {
    ev.client = CLIENT;
    ev.visitor = VISITOR;
    ev.path = ev.path || location.pathname;
    if (!ev.service && ev.service !== "") ev.service = serviceOf(ev.path);
    API.events.push(ev);
    queue.push(ev);
    if (queue.length >= 15) return flush();
    if (!flushTimer) flushTimer = setTimeout(flush, 1500);
  }
  function flush() {
    if (flushTimer) { clearTimeout(flushTimer); flushTimer = null; }
    if (!queue.length) return;
    var batch = queue.splice(0, 20);
    beacon("/interest", { client: CLIENT, visitor: VISITOR, events: batch });
    if (queue.length) flush();
  }
  window.addEventListener("pagehide", flush);
  document.addEventListener("visibilitychange", function () { if (document.visibilityState === "hidden") { if (typeof sendSearch === "function") sendSearch(); flush(); } });

  function seenRecently(key) {
    var map = null, now = Date.now();
    try { map = JSON.parse(sessionStorage.getItem("sr_seen") || "{}"); } catch (e) { map = {}; }
    if (map[key] && now - map[key] < 1800000) return true;
    map[key] = now;
    try { sessionStorage.setItem("sr_seen", JSON.stringify(map)); } catch (e) {}
    return false;
  }

  var pendingSearch = null;
  function sendSearch() {
    if (!pendingSearch) return;
    var ev = pendingSearch.ev;
    clearTimeout(pendingSearch.timer);
    pendingSearch = null;
    interest(ev);
  }
  window.addEventListener("pagehide", function () { sendSearch(); flush(); });

  function itemFromMeta(d) {
    if (!d) return null;
    var id = d.content_ids && d.content_ids[0] ? String(d.content_ids[0]) : "";
    return {
      item_id: id,
      item_name: d.content_name || "",
      item_group: d.body_type || "",
      category: d.vehicle_category || "",
      condition: d.vehicle_condition || "",
      powertrain: d.powertrain || "",
      price: d.value || null
    };
  }

  function onMetaEvent(rec) {
    if (!rec || !rec.data) return;
    var d = rec.data, e;
    if (rec.event === "VehicleView") {
      e = itemFromMeta(d);
      if (!e || !(e.item_id || e.item_name)) return;
      if (seenRecently("v:" + (e.item_id || e.item_name))) return;
      e.type = "item_view";
      interest(e);
    } else if (rec.event === "Search") {
      if (pendingSearch) clearTimeout(pendingSearch.timer);
      pendingSearch = { ev: { type: "search", query: d.search_string || "", filters: d.filters || "", results: d.results,
        condition: d.vehicle_condition || "" } };
      pendingSearch.timer = setTimeout(sendSearch, 2500);
    } else if (rec.event === "ServiceInterest" || rec.event === "COERenewalInterest") {
      var s = d.service || d.content_name || "";
      if (s && !seenRecently("s:" + s)) interest({ type: "service_interest", service: s });
    }
  }

  function hookFired(api) {
    if (!api || !api.fired || api.fired.__srHooked) return !!(api && api.fired && api.fired.__srHooked);
    var arr = api.fired;
    for (var i = 0; i < arr.length; i++) { try { onMetaEvent(arr[i]); } catch (e) {} }
    var push = arr.push;
    arr.push = function () {
      for (var j = 0; j < arguments.length; j++) { try { onMetaEvent(arguments[j]); } catch (e) {} }
      return push.apply(arr, arguments);
    };
    arr.__srHooked = true;
    return true;
  }

  (function startInterest() {
    var ref = "";
    try { ref = document.referrer ? new URL(document.referrer).origin : ""; } catch (e) {}
    if (ref === location.origin) ref = "";
    interest({ type: "page_view", referrer: ref });
    var tries = 0;
    (function wait() {
      if (hookFired(window.SR_META_TRACKER)) return;
      if (++tries < 40) setTimeout(wait, 250);
    })();
  })();

  function sgMobile(raw) {
    var d = String(raw || "").replace(/[^\d]/g, "");
    if (d.length === 12 && d.indexOf("0065") === 0) d = d.slice(4);
    if (d.length === 10 && d.indexOf("65") === 0) d = d.slice(2);
    if (!/^[89]\d{7}$/.test(d)) return "";
    if (OWN_NUMBERS.indexOf(d) > -1) return "";
    if (/^(\d)\1{7}$/.test(d) || d === "91234567" || d === "81234567" || d === "98765432" || d === "87654321") return "";
    return "+65 " + d.slice(0, 4) + " " + d.slice(4);
  }
  var OWN_NUMBERS = ["89468228", "80920332"];
  var BAD_EMAIL_DOMAINS = /@(example\.(com|org|net)|test\.com|mailinator\.com|yopmail\.com|guerrillamail\.com|10minutemail\.com|tempmail\.[a-z]+)$/i;
  function validEmail(s) {
    s = trim(s);
    return /^[^\s@]+@[^\s@]+\.[a-z]{2,}$/i.test(s) && !BAD_EMAIL_DOMAINS.test(s);
  }
  var PLACEHOLDER_NAME = /\b(test|testing|dummy|asdf|qwerty|sample|no name)\b/i;
  var NAME_CHARS = new RegExp("[a-z" + String.fromCharCode(0xC0, 45, 0x24F, 0x4E00, 45, 0x9FFF) + "]", "i");
  function validName(s) {
    s = trim(s);
    return s.length >= 2 && s.length <= 80 && NAME_CHARS.test(s) &&
      !/https?:|www\.|@/i.test(s) && !PLACEHOLDER_NAME.test(s);
  }
  function messageProblem(s) {
    s = trim(s);
    if (s.length < 3) return "Please tell us what you need.";
    if (/https?:\/\/|www\./i.test(s)) return "Please remove links from the message.";
    return "";
  }
  function throttled() {
    var list = store("sr_gate_sent") || [], now = Date.now();
    list = list.filter(function (t) { return now - t < 600000; });
    return list.length >= 5;
  }
  function noteSent() {
    var list = store("sr_gate_sent") || [], now = Date.now();
    list = list.filter(function (t) { return now - t < 600000; });
    list.push(now);
    store("sr_gate_sent", list);
  }
  function remembered() {
    var me = store("sr_gate_me");
    if (!me || Date.now() - (me.t || 0) > 60 * 86400000 || !validName(me.n) || !sgMobile(me.p)) {
      if (me) { try { localStorage.removeItem("sr_gate_me"); } catch (e) {} }
      return { n: "", p: "", e: "" };
    }
    return me;
  }
  function remember(name, phone, email) {
    store("sr_gate_me", { n: name, p: phone, e: email, t: Date.now() });
  }

  function parseWa(url) {
    var out = { phone: "", text: "" };
    try {
      var u = new URL(url, location.href);
      out.phone = u.searchParams.get("phone") || "";
      out.text = u.searchParams.get("text") || "";
      if (!out.phone) { var m = /wa\.me\/\+?(\d{6,})/.exec(url); if (m) out.phone = m[1]; }
    } catch (e) {}
    return out;
  }
  function labelled(text, labels) {
    var lines = String(text || "").split("\n");
    for (var i = 0; i < lines.length; i++) {
      var line = trim(lines[i]), low = line.toLowerCase();
      for (var j = 0; j < labels.length; j++) {
        var k = low.indexOf(labels[j] + ":");
        if (k > -1 && k <= 4) { var v = trim(line.slice(k + labels[j].length + 1)); if (v) return v; }
      }
    }
    return "";
  }
  function vehicleFromText(text) {
    var t = String(text || ""), v = { item_id: "", item_name: "", category: "", price: "", photo: "" };
    var m = /[?&]v=([a-z0-9-]+)/i.exec(t);
    if (m) v.item_id = m[1];
    m = /(?:^|\n)\s*(?:🚛|🚗)\s*\*?([^*\n]+?)\*?\s*(?:\n|$)/.exec(t);
    if (m) v.item_name = trim(m[1]);
    v.category = labelled(t, ["category"]);
    v.price = labelled(t, ["base price", "price"]);
    m = /Photo:\s*(https:\/\/\S+)/i.exec(t);
    if (m) v.photo = m[1];
    return v.item_name || v.item_id ? v : null;
  }

  var nativeChainOpen = null;
  var passing = false;
  function openWhatsApp(url) {
    if (window.ABLWA) window.ABLWA._skipWaOpen = true;
    passing = true;
    var w = null;
    try { w = nativeChainOpen.call(window, url, "_blank"); } catch (e) {}
    passing = false;
    if (window.ABLWA) window.ABLWA._skipWaOpen = false;
    if (w) { try { w.opener = null; } catch (e) {} }
    else location.href = url;
  }

  function waUrl(number, text) {
    return "https://api.whatsapp.com/send?phone=" + encodeURIComponent(number) + "&text=" + encodeURIComponent(text);
  }
  function defaultNumber() {
    try { return JSON.parse(document.getElementById("ablink-wa-config").textContent).waNumber || "6589468228"; }
    catch (e) { return "6589468228"; }
  }

  function refCode() {
    var chars = "ABCDEFGHJKLMNPQRSTUVWXYZ23456789", out = "", rnd = [];
    try { rnd = window.crypto.getRandomValues(new Uint8Array(4)); } catch (e) {}
    for (var i = 0; i < 4; i++) out += chars.charAt((rnd[i] === undefined ? Math.floor(Math.random() * 256) : rnd[i]) % chars.length);
    return "ABL-" + out;
  }

  var LEAD_DECO = new RegExp("^(?:\\s|[" + String.fromCharCode(0x2190, 45, 0x21FF, 0x2300, 45, 0x23FF, 0x2460, 45, 0x24FF, 0x25A0, 45, 0x27BF, 0x2900, 45, 0x297F, 0x2B00, 45, 0x2BFF, 0xFE0F, 0x200D, 0x20E3) + "]|[" + String.fromCharCode(0xD83C, 45, 0xD83E) + "][" + String.fromCharCode(0xDC00, 45, 0xDFFF) + "])+");
  var GREETING = /^(?:hi|hello|hey|dear)\b(?:\s+(?:there|team|ablink(?:\.sg)?(?:\s+team)?))?\s*[!,.:]*\s*/i;
  var GENERIC = /^(?:i would like to chat(?: with you)? directly|i would like to chat)\.?$/i;
  var SECTION_SKIP = { "customer": 1, "my details": 1, "message": 1, "message / request": 1 };

  function plainLine(raw) {
    var t = trim(String(raw || "").replace(LEAD_DECO, ""));
    return trim(t.replace(/\*/g, "").replace(LEAD_DECO, ""));
  }

  function readSource(text) {
    var out = { title: "", lines: [], enquiry: "" };
    var skip = false;
    var lines = String(text || "").replace(/\r/g, "").split("\n");
    for (var i = 0; i < lines.length; i++) {
      var line = plainLine(lines[i]);
      var head = line.toLowerCase().replace(/^[\s\-–—]+|[\s\-–—:]+$/g, "");
      if (SECTION_SKIP[head]) { skip = true; continue; }
      if (head === "vehicle of interest") { skip = false; out.title = "Vehicle"; continue; }
      if (head === "coe details") { skip = false; out.title = "COE renewal"; continue; }
      if (skip) continue;
      if (!line) { out.lines.push(""); continue; }
      if (GREETING.test(line)) {
        line = trim(line.replace(GREETING, "").replace(LEAD_DECO, "").replace(/^[,.!:\s]+/, ""));
        if (!line || GENERIC.test(line)) continue;
      }
      var m = /^enquiry type\s*:\s*(.+)$/i.exec(line);
      if (m) { out.enquiry = trim(m[1]); continue; }
      if (/^i am interested in this vehicle|^i would like to enquire about the following vehicle/i.test(line)) { out.title = out.title || "Vehicle"; continue; }
      if (/^could you share more details\??$/i.test(line)) continue;
      if (/^(?:name|e-?mail|mobile|phone|contact|(?:my )?(?:upfront )?budget)\s*:/i.test(line)) continue;
      out.lines.push(line);
    }
    var tidy = [];
    for (var j = 0; j < out.lines.length; j++) {
      if (!out.lines[j] && (!tidy.length || !tidy[tidy.length - 1])) continue;
      tidy.push(out.lines[j]);
    }
    while (tidy.length && !tidy[tidy.length - 1]) tidy.pop();
    out.lines = tidy;
    if (out.lines.length && !out.title) out.title = "Details";
    return out;
  }

  function budgetText(raw) {
    var t = trim(raw);
    if (!t) return "";
    var n = Number(t.replace(/[^\d.]/g, ""));
    if (!n || /[a-z]/i.test(t.replace(/^s?gd|^s\$/i, ""))) return t;
    return "S$" + String(Math.round(n)).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  }

  function composeText(o, ref) {
    var L = ["Hello " + BRAND + " 👋"];
    if (o.enquiry) L.push("Enquiry type: " + o.enquiry);
    if (o.message) L.push("", o.message);
    var info = o.info || { title: "", lines: [] };
    if (info.lines.length) L = L.concat(["", "*" + info.title + "*"], info.lines);
    if (o.name || o.phone) {
      L.push("", "*My details*", "Name: " + o.name, "Mobile: " + o.phone);
      if (o.email) L.push("Email: " + o.email);
      if (o.budget) L.push("Upfront budget: " + o.budget);
    }
    if (ref) L.push("", "Ref: " + ref);
    return L.join("\n");
  }

  function metaLead(o) {
    if (typeof window.fbq !== "function") return;
    var item = o.item || {};
    var d = {
      content_name: item.item_name || o.enquiry || o.label || "Enquiry",
      content_category: o.service || "",
      content_type: item.item_id ? "product" : "service",
      service: o.service || "",
      source_page: location.pathname,
      currency: "SGD"
    };
    if (item.item_id) d.content_ids = [String(item.item_id)];
    try { window.fbq("track", "Lead", d); } catch (e) {}
  }

  function complete(o) {
    var ft = firstTouch();
    var ref = refCode();
    var text = composeText(o, ref);
    var row = {
      client: CLIENT,
      name: o.name, phone: o.phone, email: o.email, ref: ref,
      website: o.item ? o.item.item_name || "" : "",
      message: "Enquiry form (WhatsApp) - " + o.label + "\n\n" + text,
      wa_number: o.number,
      page: location.href, title: document.title, referrer: document.referrer || "",
      first_page: ft.p || "", first_referrer: ft.r || "", first_ts: ft.t || "",
      vehicle: o.item ? o.item.item_name : "", enquiry_type: o.enquiry || o.topic || "",
      ts: new Date().toISOString()
    };
    var g = adClickId();
    if (g) row.gclid = g;
    API.sent.push(row);
    beacon("/track", row);
    var ev = { type: "enquiry", service: o.service || serviceOf() };
    if (o.item) for (var k in o.item) if (o.item.hasOwnProperty(k) && k !== "photo") ev[k] = o.item[k];
    interest(ev);
    flush();
    if (o.metaLead !== false) metaLead(o);
    remember(o.name, o.phone, o.email);
    noteSent();
    log("enquiry", row);
    openWhatsApp(waUrl(o.number, text));
  }

  var NO_EMAIL = "no-email@sr-gate.invalid";
  function holdEmptyEmail(input) {
    if (!input || trim(input.value)) return;
    input.value = NO_EMAIL;
    setTimeout(function () { if (input.value === NO_EMAIL) input.value = ""; }, 0);
  }

  var lastFormOpen = 0;
  var lastUsedItem = null;
  var widgetLead = null;

  function phoneFieldHtml(id, cls, labelCls, wrapCls, star) {
    var r = remembered();
    return '<div class="' + wrapCls + ' sr-gate-injected">' +
      '<label class="' + labelCls + '" for="' + id + '">Mobile Number (Singapore)' + star + "</label>" +
      '<input class="' + cls + ' sr-gate-phone" id="' + id + '" type="tel" inputmode="tel" autocomplete="tel-national" ' +
      'placeholder="e.g. 9123 4567" maxlength="16" value="' + esc(r.p ? r.p.replace(/^\+65\s?/, "") : "") + '">' +
      '<div class="sr-gate-inline-err" role="alert"></div></div>';
  }

  function injectFields() {
    var forms = document.querySelectorAll(".t8-enq-form");
    for (var i = 0; i < forms.length; i++) {
      var f = forms[i];
      if (f.querySelector(".sr-gate-phone")) continue;
      var row = f.querySelector(".t8-enq-row");
      if (!row) continue;
      var holder = document.createElement("div");
      holder.innerHTML = phoneFieldHtml("sr-gate-phone-t8-" + i, "t8-enq-input", "t8-enq-label", "t8-enq-field", " (optional)");
      row.parentNode.insertBefore(holder.firstChild, row.nextSibling);
      ["t8-enq-email-", "t8-enq-budget-", "t8-enq-msg-"].forEach(function (pfx) {
        var el = f.querySelector('[id^="' + pfx + '"]');
        var w = el && el.closest ? el.closest(".t8-enq-field") : null;
        if (w && w.parentNode) w.parentNode.removeChild(w);
      });
      row.style.gridTemplateColumns = "1fr";
      var msgLabel = null, labels = f.querySelectorAll(".t8-enq-label");
      for (var j = 0; j < labels.length; j++) if (/message/i.test(labels[j].textContent)) msgLabel = labels[j];
      if (msgLabel && !msgLabel.querySelector("span")) msgLabel.insertAdjacentHTML("beforeend", "<span>*</span>");
      for (var q = 0; q < labels.length; q++) {
        if (/email/i.test(labels[q].textContent)) labels[q].innerHTML = "Email Address (optional)";
        if (/full name/i.test(labels[q].textContent)) labels[q].textContent = "Full Name (optional)";
      }
      var privacy = f.querySelector(".t8-enq-privacy");
      if (privacy && !privacy.querySelector(".sr-gate-consent")) privacy.insertAdjacentHTML("beforeend", ' <span class="sr-gate-consent">' + consentHtml() + "</span>");
    }
    var screen = document.getElementById("screen-form");
    var nameIn = document.getElementById("wa_name");
    if (screen && nameIn && !document.getElementById("wa_phone")) {
      var group = nameIn.closest ? nameIn.closest(".form-group") : nameIn.parentNode;
      var h = document.createElement("div");
      h.innerHTML = phoneFieldHtml("wa_phone", "", "", "form-group", " (optional)");
      group.parentNode.insertBefore(h.firstChild, group.nextSibling);
      var foot = screen.querySelector(".wa-footer");
      if (foot) foot.insertAdjacentHTML("beforebegin", '<p class="sr-gate-consent sr-gate-consent-widget">' + consentHtml() + "</p>");
    }
    if (window.ABLWA && !window.ABLWA.__srGate) {
      window.ABLWA.__srGate = true;
      window.ABLWA.trackLead = function (p) { widgetLead = { at: Date.now(), p: p || {} }; };
    }
    slimWidget();
  }

  function slimWidget() {
    var A = window.ABLWA;
    if (!A || A.__srSlim || !document.getElementById("screen-form")) return;
    A.__srSlim = true;
    ["wa_email", "wa_budget", "wa_message"].forEach(function (id) {
      var el = document.getElementById(id);
      var g = el && el.closest ? el.closest(".form-group") : null;
      if (g && g.parentNode) g.parentNode.removeChild(g);
    });
    var cfg = {};
    try { cfg = JSON.parse(document.getElementById("ablink-wa-config").textContent) || {}; } catch (e) {}
    A.send = function () {
      var nameEl = document.getElementById("wa_name");
      var name = trim(nameEl ? nameEl.value : "");
      var err = document.getElementById("wa-error-msg");
      if (err) err.style.display = "none";
      var st = A.state || {}, modes = cfg.modes || {};
      var typeLabel = st.mode === "coe" ? "COE Renewal" : ((modes[st.mode] && modes[st.mode].label) || "Vehicle");
      var L = ["Hello ABLINK.SG 👋", "", "*Enquiry Type:* " + typeLabel, "", "— Customer —"].concat(name ? ["Name: " + name, ""] : [""]);
      if (st.mode === "coe" && st.coe) {
        var co = st.coe;
        L.push("— COE Details —", "Category: " + co.cat, "Renewal Term: " + co.term);
        if (co.reg) L.push("Reg No: " + co.reg);
        if (co.expiry) L.push("COE Expiry: " + co.expiry);
      } else if (st.vehicle) {
        var v = st.vehicle;
        L.push("— Vehicle of Interest —", v.title);
        if (v.sub) L.push(v.sub);
        if (v.price) L.push("Price: " + v.price);
        if (v.atts && v.atts.length) L.push("Attachments: " + v.atts.join(", "));
        if (v.extras && v.extras.length) for (var i = 0; i < v.extras.length; i++) L.push(v.extras[i]);
      }
      A.trackLead({
        name: name, email: "",
        website: (st.vehicle && st.vehicle.title) || "",
        vehicle: (st.vehicle && st.vehicle.title) || "",
        category: (st.vehicle && st.vehicle.cat) || "",
        price: (st.vehicle && st.vehicle.price) || "",
        enquiry_type: typeLabel,
        message: L.join("\n")
      });
      A._skipWaOpen = true;
      window.open("https://api.whatsapp.com/send?phone=" + (cfg.waNumber || defaultNumber()) + "&text=" + encodeURIComponent(L.join("\n")), "_blank", "noopener");
    };
  }

  function consentHtml() {
    return "By continuing you agree " + BRAND + " may contact you about this enquiry. Your details are used only to reply to you " +
      '(<a href="' + PRIVACY_URL + '" target="_blank" rel="noopener">privacy policy</a>).';
  }

  function inlineError(input, msg) {
    var wrap = input && (input.closest ? input.closest(".sr-gate-injected") : null);
    var box = wrap ? wrap.querySelector(".sr-gate-inline-err") : null;
    if (box) { box.textContent = msg || ""; box.style.display = msg ? "block" : "none"; }
    if (input) {
      if (msg) { input.classList.add("error"); try { input.focus(); input.scrollIntoView({ block: "center", behavior: "smooth" }); } catch (e) {} }
      else input.classList.remove("error");
    }
  }

  function formProblem(scope, isSheet) {
    var phoneEl = scope.querySelector(".sr-gate-phone");
    if (!phoneEl) return false;
    var nameEl = scope.querySelector(isSheet ? '[id^="t8-enq-name-"]' : "#wa_name");
    var emailEl = scope.querySelector(isSheet ? '[id^="t8-enq-email-"]' : "#wa_email");
    var msgEl = scope.querySelector(isSheet ? '[id^="t8-enq-msg-"]' : "#wa_message");
    var say = function (el, msg) {
      inlineError(phoneEl, msg);
      if (el && el !== phoneEl) { el.classList.add("error"); try { el.focus(); } catch (x) {} }
      if (!isSheet && window.ABLWA && window.ABLWA.fail) window.ABLWA.fail(msg);
      return true;
    };
    inlineError(phoneEl, "");
    if (nameEl) nameEl.classList.remove("error");
    if (emailEl) emailEl.classList.remove("error");
    if (msgEl) msgEl.classList.remove("error");
    if (!trim(nameEl ? nameEl.value : "") && !trim(phoneEl.value)) return false;
    if (nameEl && !validName(nameEl.value)) return say(nameEl, "Please enter your full name.");
    var email = emailEl ? trim(emailEl.value) : "";
    if (email && email !== NO_EMAIL && !validEmail(email)) return say(emailEl, "Please enter a valid email address.");
    if (!sgMobile(phoneEl.value)) return say(phoneEl, "Please enter a valid Singapore mobile number (8 digits, starting with 8 or 9).");
    var mp = msgEl ? messageProblem(msgEl.value) : "";
    if (mp) return say(msgEl, mp);
    if (Date.now() - lastFormOpen < 1200 || throttled()) return say(phoneEl, "Please wait a moment and try again.");
    return false;
  }

  function handleUsedSheet(url) {
    var ov = document.querySelector(".t8-enq-ov.open");
    if (!ov) return false;
    var get = function (sel) { var el = ov.querySelector(sel); return el ? trim(el.value) : ""; };
    var phoneEl = ov.querySelector(".sr-gate-phone");
    var msgEl = ov.querySelector('[id^="t8-enq-msg-"]');
    var wa = parseWa(url);
    var name = get('[id^="t8-enq-name-"]'), email = get('[id^="t8-enq-email-"]');
    var phone = sgMobile(phoneEl ? phoneEl.value : "");
    if (!phoneEl) return false;
    inlineError(phoneEl, "");
    if (!name && !trim(phoneEl.value)) {
      sendAnon(url, lastUsedItem || vehicleFromText(wa.text), "Used vehicles");
      closeUsedSheet();
      return true;
    }
    if (!validName(name)) { var n = ov.querySelector('[id^="t8-enq-name-"]'); if (n) n.classList.add("error"); return true; }
    if (email === NO_EMAIL) email = "";
    if (email && !validEmail(email)) { var em = ov.querySelector('[id^="t8-enq-email-"]'); if (em) em.classList.add("error"); return true; }
    if (!phone) { inlineError(phoneEl, "Please enter a valid Singapore mobile number (8 digits, starting with 8 or 9)."); return true; }
    var mp = msgEl ? messageProblem(msgEl.value) : "";
    if (mp) { if (msgEl) { msgEl.classList.add("error"); msgEl.placeholder = mp; try { msgEl.focus(); } catch (e) {} } return true; }
    if (Date.now() - lastFormOpen < 1200 || throttled()) { inlineError(phoneEl, "Please wait a moment and try again."); return true; }
    if (msgEl) msgEl.classList.remove("error");
    var item = lastUsedItem || vehicleFromText(wa.text);
    var info = readSource(wa.text);
    if (info.lines.length) info.title = "Vehicle";
    complete({
      name: name, phone: phone, email: email, number: wa.phone || defaultNumber(),
      message: trim(msgEl ? msgEl.value : ""), info: info, enquiry: "Used commercial vehicle",
      budget: budgetText(get('[id^="t8-enq-budget-"]')),
      label: (item && item.item_name) || "Used vehicle", topic: "Used commercial vehicle", service: "Used vehicles", item: item
    });
    closeUsedSheet();
    return true;
  }
  function closeUsedSheet() {
    try {
      var closer = Object.keys(window).filter(function (k) { return k.indexOf("t8CloseEnq_") === 0; });
      for (var c = 0; c < closer.length; c++) window[closer[c]]();
    } catch (e) {}
  }

  function handleWidget(url) {
    if (!widgetLead || Date.now() - widgetLead.at > 3000) return false;
    var p = widgetLead.p;
    widgetLead = null;
    var phoneEl = document.getElementById("wa_phone");
    if (!phoneEl) return false;
    var phone = sgMobile(phoneEl.value);
    var fail = function (msg) {
      inlineError(phoneEl, msg);
      if (window.ABLWA && window.ABLWA.fail) window.ABLWA.fail(msg);
    };
    inlineError(phoneEl, "");
    if (!trim(p.name) && !trim(phoneEl.value)) {
      sendAnon(url, p.vehicle ? { item_id: "", item_name: p.vehicle } : null, serviceOf());
      if (window.ABLWA && window.ABLWA.open) { var wc = document.getElementById("wa-card"); if (wc) wc.style.display = "none"; }
      return true;
    }
    if (!validName(p.name)) { fail("Please enter your full name."); return true; }
    if (p.email === NO_EMAIL) p.email = "";
    if (p.email && !validEmail(p.email)) { fail("Please enter a valid email address."); return true; }
    if (!phone) { fail("Please enter a valid Singapore mobile number (8 digits, starting with 8 or 9)."); return true; }
    var mp = document.getElementById("wa_message") ? messageProblem(document.getElementById("wa_message").value) : "";
    if (mp) { fail(mp); return true; }
    if (Date.now() - lastFormOpen < 1200 || throttled()) { fail("Please wait a moment and try again."); return true; }
    var wa = parseWa(url);
    var info = readSource(wa.text);
    var item = p.vehicle ? { item_id: "", item_name: p.vehicle, category: p.category || "", price: p.price || "" } : null;
    var svc = /coe/i.test(p.enquiry_type || "") ? "COE renewal loan" : /used/i.test(p.enquiry_type || "") ? "Used vehicles" : /new/i.test(p.enquiry_type || "") ? "New vehicles" : serviceOf();
    var budgetEl = document.getElementById("wa_budget");
    var msgEl = document.getElementById("wa_message");
    complete({
      name: trim(p.name), phone: phone, email: trim(p.email), number: wa.phone || defaultNumber(),
      message: trim(msgEl ? msgEl.value : ""), info: info, enquiry: p.enquiry_type || info.enquiry || "",
      budget: budgetText(budgetEl ? budgetEl.value : ""),
      label: "Widget - " + (p.enquiry_type || "Enquiry") + (p.vehicle ? " - " + p.vehicle : ""), topic: p.enquiry_type || "",
      service: svc, item: item,
      metaLead: false
    });
    if (window.ABLWA && window.ABLWA.open) { var card = document.getElementById("wa-card"); if (card) card.style.display = "none"; }
    return true;
  }

  var gate = null;

  function css() {
    if (document.getElementById("sr-gate-css")) return;
    var s = document.createElement("style");
    s.id = "sr-gate-css";
    s.textContent = [
      ":root{" +
        "--srg-navy-ink:#182A3A;" +
        "--srg-slate-text:#5B6776;" +
        "--srg-slate-note:#6B7684;" +
        "--srg-brand-orange:#F58A07;" +
        "--srg-brand-orange-ring:rgba(245,138,7,.18);" +
        "--srg-whatsapp-green:#25D366;" +
        "--srg-whatsapp-green-hover:#1EBE5A;" +
        "--srg-paper-white:#FFFFFF;" +
        "--srg-hairline-grey:#EEF0F3;" +
        "--srg-field-border-grey:#D8DEE4;" +
        "--srg-mist-surface:#FAFBFC;" +
        "--srg-cloud-grey:#F3F5F7;" +
        "--srg-error-red:#B3261E;" +
        "--srg-error-border-red:#D93025;" +
        "--srg-backdrop-navy:rgba(15,23,34,.55);" +
        "--srg-shadow-black:rgba(0,0,0,.45)" +
      "}",
      "#sr-gate{position:fixed;inset:0;z-index:2147483000;display:none;align-items:center;justify-content:center;padding:16px;background:var(--srg-backdrop-navy);font-family:'Plus Jakarta Sans',-apple-system,BlinkMacSystemFont,'Segoe UI',Roboto,Arial,sans-serif;-webkit-font-smoothing:antialiased}",
      "#sr-gate.open{display:flex}",
      "#sr-gate *{box-sizing:border-box}#sr-gate [hidden]{display:none!important}",
      "#sr-gate .srg-card{position:relative;width:100%;max-width:440px;max-height:calc(100vh - 32px);overflow:auto;background:var(--srg-paper-white);border-radius:18px;box-shadow:0 30px 80px -20px var(--srg-shadow-black);color:var(--srg-navy-ink);animation:srg-in .22s ease-out}",
      "@keyframes srg-in{from{opacity:0;transform:translateY(14px)}to{opacity:1;transform:none}}",
      "@media (prefers-reduced-motion:reduce){#sr-gate .srg-card{animation:none}}",
      "#sr-gate .srg-head{padding:20px 22px 14px;border-bottom:1px solid var(--srg-hairline-grey)}",
      "#sr-gate .srg-brand{font-size:11px;font-weight:800;letter-spacing:.14em;text-transform:uppercase;color:var(--srg-brand-orange)}",
      "#sr-gate h2{margin:6px 0 4px;font-size:20px;line-height:1.25;font-weight:800;color:var(--srg-navy-ink)}",
      "#sr-gate .srg-sub{margin:0;font-size:13px;line-height:1.5;color:var(--srg-slate-text)}",
      "#sr-gate .srg-x{position:absolute;top:12px;right:12px;width:36px;height:36px;border:0;border-radius:50%;background:var(--srg-cloud-grey);color:var(--srg-navy-ink);font-size:20px;line-height:36px;cursor:pointer}",
      "#sr-gate .srg-body{padding:16px 22px 20px}",
      "#sr-gate .srg-item{display:flex;gap:12px;align-items:center;padding:10px;border:1px solid var(--srg-hairline-grey);border-radius:12px;background:var(--srg-mist-surface);margin-bottom:14px}",
      "#sr-gate .srg-item img{width:64px;height:48px;object-fit:cover;border-radius:8px;flex:none;background:var(--srg-hairline-grey)}",
      "#sr-gate .srg-item b{display:block;font-size:14px;line-height:1.3}",
      "#sr-gate .srg-item span{display:block;font-size:12px;color:var(--srg-slate-text);margin-top:2px}",
      "#sr-gate .srg-f{margin-bottom:12px}",
      "#sr-gate label{display:block;font-size:11px;font-weight:800;letter-spacing:.05em;text-transform:uppercase;color:var(--srg-slate-text);margin-bottom:5px}",
      "#sr-gate input,#sr-gate select,#sr-gate textarea{width:100%;font:inherit;font-size:16px;color:var(--srg-navy-ink);background:var(--srg-paper-white);border:1px solid var(--srg-field-border-grey);border-radius:10px;padding:11px 13px;outline:none;-webkit-appearance:none;appearance:none}",
      "#sr-gate textarea{min-height:84px;resize:vertical}",
      "#sr-gate input:focus,#sr-gate select:focus,#sr-gate textarea:focus{border-color:var(--srg-brand-orange);box-shadow:0 0 0 3px var(--srg-brand-orange-ring)}",
      "#sr-gate .srg-bad input,#sr-gate .srg-bad select,#sr-gate .srg-bad textarea{border-color:var(--srg-error-border-red)}",
      "#sr-gate .srg-err{display:none;margin-top:5px;font-size:12px;color:var(--srg-error-red)}",
      "#sr-gate .srg-bad .srg-err{display:block}",
      "#sr-gate .srg-phone{display:flex;align-items:stretch}",
      "#sr-gate .srg-phone i{display:flex;align-items:center;padding:0 12px;font-style:normal;font-weight:700;font-size:15px;background:var(--srg-cloud-grey);border:1px solid var(--srg-field-border-grey);border-right:0;border-radius:10px 0 0 10px}",
      "#sr-gate .srg-phone input{border-radius:0 10px 10px 0}",
      "#sr-gate .srg-hp{position:absolute;left:-9999px;width:1px;height:1px;opacity:0}",
      "#sr-gate .srg-go{display:flex;width:100%;align-items:center;justify-content:center;gap:9px;margin-top:4px;padding:14px 16px;border:0;border-radius:12px;background:var(--srg-whatsapp-green);color:var(--srg-paper-white);font:inherit;font-size:15px;font-weight:800;cursor:pointer}",
      "#sr-gate .srg-go:hover{background:var(--srg-whatsapp-green-hover)}",
      "#sr-gate .srg-go svg{width:20px;height:20px;fill:var(--srg-paper-white);flex:none}",
      "#sr-gate .srg-consent,.sr-gate-consent{margin:10px 0 0;font-size:11.5px;line-height:1.5;color:var(--srg-slate-note)}",
      "#sr-gate .srg-consent a,.sr-gate-consent a{color:inherit;text-decoration:underline}",
      ".sr-gate-inline-err{display:none;margin-top:5px;font-size:12px;color:var(--srg-error-red)}",
      ".sr-gate-consent-widget{margin:10px 0 6px}",
      "@media (max-width:600px){#sr-gate{align-items:flex-end;padding:0}#sr-gate .srg-card{max-width:none;max-height:92vh;border-radius:18px 18px 0 0;padding-bottom:env(safe-area-inset-bottom)}}",
      "#sr-gate{font-family:Inter,-apple-system,BlinkMacSystemFont,'Segoe UI',Roboto,Arial,sans-serif!important}",
      "#sr-gate .srg-card{border-radius:20px;color:#17191C}",
      "#sr-gate .srg-brand{color:#F58220}",
      "#sr-gate h2#srg-title{color:#17191C!important;font-family:Manrope,Inter,system-ui,sans-serif!important;font-size:21px!important;font-weight:800!important;letter-spacing:-.01em!important;text-transform:none!important}",
      "#sr-gate .srg-sub{color:#5F6670}",
      "#sr-gate label{color:#5F6670}",
      "#sr-gate .srg-go{min-height:54px;border-radius:14px;background:#25D366;color:#08260F;font-weight:800}",
      "#sr-gate .srg-go:hover{background:#1FBE5A}",
      "#sr-gate .srg-go svg{fill:#08260F}",
      "#sr-gate .sr-sum{margin:0 0 14px!important;padding:14px 16px!important;border-radius:18px!important;background:linear-gradient(145deg,rgba(255,244,232,.95),rgba(255,255,255,.85))!important;border:1px solid rgba(245,130,32,.45)!important;box-shadow:inset 0 1px 0 rgba(255,255,255,.9)!important;color:#17191C!important}",
      "#sr-gate .sr-sum__t{margin:0 0 8px!important;font-size:13px!important;font-weight:800!important;line-height:1.3!important;letter-spacing:.04em!important;text-transform:uppercase!important;color:#BA540B!important}",
      "#sr-gate .sr-sum__t small{display:block!important;margin-top:2px!important;font-size:11.5px!important;font-weight:600!important;letter-spacing:0!important;text-transform:none!important;color:#5F6670!important}",
      "#sr-gate .sr-sum__t--loan{margin-top:12px!important;padding-top:10px!important;border-top:1px dashed rgba(186,84,11,.35)!important}",
      "#sr-gate .sr-sum__r{display:flex!important;justify-content:space-between!important;gap:12px!important;padding:4px 0!important;font-size:14px!important;font-weight:500!important;line-height:1.35!important}",
      "#sr-gate .sr-sum__r span{color:#3F4A55!important}",
      "#sr-gate .sr-sum__r b{font-weight:800!important;color:#17191C!important;text-align:right!important}",
      "#sr-gate .sr-sum__r.has-ic{align-items:center!important}",
      "#sr-gate .sr-sum__ic{flex:0 0 40px!important;width:40px!important;height:40px!important;border-radius:10px!important;background:#fff!important;border:1px solid rgba(23,25,28,.08)!important;display:grid!important;place-items:center!important;overflow:hidden!important}",
      "#sr-gate .sr-sum__ic img,#sr-gate .sr-sum__ic svg{width:34px!important;height:34px!important;object-fit:contain!important;padding:0!important;margin:0!important}",
      "#sr-gate .sr-sum__r.has-ic span{flex:1 1 auto!important}",
      "#sr-gate .sr-sum__r.is-total{margin-top:4px!important;padding-top:8px!important;border-top:1px solid rgba(23,25,28,.1)!important}",
      "#sr-gate .sr-sum__r.is-total b{color:#BA540B!important}",
      "#sr-gate .sr-sum__cars{display:grid!important;grid-template-columns:repeat(var(--n,2),minmax(0,1fr))!important;gap:8px!important}",
      "#sr-gate .sr-sum__car{min-width:0!important;background:#fff!important;border:1px solid rgba(23,25,28,.08)!important;border-radius:12px!important;overflow:hidden!important}",
      "#sr-gate .sr-sum__car img{display:block!important;width:100%!important;height:auto!important;aspect-ratio:4/3!important;object-fit:contain!important;background:#F6F7F8!important;border-radius:0!important;margin:0!important}",
      "#sr-gate .sr-sum__car>div{padding:8px 10px 10px!important}",
      "#sr-gate .sr-sum__car b{display:block!important;font-size:13px!important;font-weight:800!important;line-height:1.25!important;color:#17191C!important;overflow-wrap:anywhere!important}",
      "#sr-gate .sr-sum__car em{display:block!important;margin-top:2px!important;font-style:normal!important;font-size:13.5px!important;font-weight:800!important;color:#BA540B!important}",
      "#sr-gate .sr-sum__car dl{margin:6px 0 0!important}",
      "#sr-gate .sr-sum__car dl div{padding:4px 0!important;border-top:1px solid rgba(23,25,28,.08)!important}",
      "#sr-gate .sr-sum__car dt{font-size:10.5px!important;color:#5F6670!important}",
      "#sr-gate .sr-sum__car dd{margin:0!important;font-size:12px!important;font-weight:700!important;color:#17191C!important}"
    ].join("");
    document.head.appendChild(s);
  }

  var WA_ICON = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 2a10 10 0 0 0-8.6 15.1L2 22l5-1.3A10 10 0 1 0 12 2Zm0 18.2a8.2 8.2 0 0 1-4.2-1.2l-.3-.2-3 .8.8-2.9-.2-.3A8.2 8.2 0 1 1 12 20.2Zm4.5-6.1c-.2-.1-1.5-.7-1.7-.8s-.4-.1-.6.1-.7.8-.8 1-.3.2-.5.1a6.7 6.7 0 0 1-3.3-2.9c-.3-.4.2-.4.7-1.3a.5.5 0 0 0 0-.4l-.8-1.9c-.2-.5-.4-.4-.6-.4h-.5a1 1 0 0 0-.7.3 3 3 0 0 0-.9 2.2 5.2 5.2 0 0 0 1.1 2.8 11.9 11.9 0 0 0 4.6 4c1.7.7 2.3.8 3.2.6a2.7 2.7 0 0 0 1.8-1.2 2.2 2.2 0 0 0 .1-1.3c0-.1-.2-.2-.4-.3Z"/></svg>';

  function build() {
    css();
    var el = document.createElement("div");
    el.id = "sr-gate";
    el.setAttribute("role", "dialog");
    el.setAttribute("aria-modal", "true");
    el.setAttribute("aria-labelledby", "srg-title");
    var opts = TOPICS.map(function (t) { return '<option value="' + esc(t) + '">' + esc(t) + "</option>"; }).join("");
    el.innerHTML =
      '<div class="srg-card">' +
        '<button type="button" class="srg-x" aria-label="Close">&times;</button>' +
        '<div class="srg-head"><div class="srg-brand">' + BRAND + "</div>" +
          '<h2 id="srg-title">Send on WhatsApp</h2>' +
          '<p class="srg-sub">Add your name and mobile if you would like a call back. Both are optional.</p></div>' +
        '<form class="srg-body" novalidate>' +
          '<div class="srg-item" hidden><img alt="" width="64" height="48"><div><b></b><span></span></div></div>' +
          '<div class="srg-f" data-f="name"><label for="srg-name">Full name (optional)</label><input id="srg-name" name="name" autocomplete="name" maxlength="80"><div class="srg-err">Please enter your full name.</div></div>' +
          '<div class="srg-f" data-f="phone"><label for="srg-phone">Mobile number (optional)</label><div class="srg-phone"><i>+65</i><input id="srg-phone" name="phone" type="tel" inputmode="tel" autocomplete="tel-national" placeholder="9123 4567" maxlength="14"></div><div class="srg-err">Please enter a valid Singapore mobile number (8 digits, starting with 8 or 9).</div></div>' +
          '<div class="srg-f" data-f="topic"><label for="srg-topic">What do you need? (optional)</label><select id="srg-topic" name="topic"><option value="">Choose one…</option>' + opts + '</select><div class="srg-err">Please choose what you need.</div></div>' +
          '<div class="srg-f" data-f="vehicle" hidden><label for="srg-vehicle">Vehicle (optional)</label><input id="srg-vehicle" name="vehicle" list="srg-vehicles" maxlength="120" placeholder="Start typing a model…"><datalist id="srg-vehicles"></datalist></div>' +
          '<input class="srg-hp" name="company" tabindex="-1" autocomplete="off" aria-hidden="true">' +
          '<button type="submit" class="srg-go">' + WA_ICON + "<span>Send on WhatsApp</span></button>" +
          '<p class="srg-consent">' + consentHtml() + "</p>" +
        "</form>" +
      "</div>";
    document.body.appendChild(el);

    var form = el.querySelector("form");
    el.querySelector(".srg-x").addEventListener("click", close);
    el.addEventListener("click", function (e) { if (e.target === el) close(); });
    document.addEventListener("keydown", function (e) { if (e.key === "Escape" && el.classList.contains("open")) close(); });
    window.addEventListener("submit", function (e) {
      if (e.target !== form) return;
      e.preventDefault();
      e.stopPropagation();
      submit();
    }, true);
    el.querySelector("#srg-topic").addEventListener("change", topicChanged);
    for (var i = 0, fs = el.querySelectorAll("input,select,textarea"); i < fs.length; i++) {
      fs[i].addEventListener("input", function (e) { var f = e.target.closest(".srg-f"); if (f) f.classList.remove("srg-bad"); });
    }
    return { el: el, form: form, ctx: null, openedAt: 0 };
  }

  function field(name) { return gate.el.querySelector('[data-f="' + name + '"]'); }
  function val(id) { var x = gate.el.querySelector("#" + id); return x ? trim(x.value) : ""; }

  var inventory = null;
  function loadInventory() {
    if (inventory) return;
    inventory = [];
    var cfg = {};
    try { cfg = JSON.parse(document.getElementById("ablink-wa-config").textContent).modes || {}; } catch (e) {}
    ["new", "used"].forEach(function (mode) {
      var m = cfg[mode];
      if (!m || !m.url || !window.fetch) return;
      var headers = {};
      if (m.apiKey && m.apiKeyHeader) headers[m.apiKeyHeader] = m.apiKey;
      fetch(m.url, { headers: headers }).then(function (r) { return r.json(); }).then(function (j) {
        var list = (m.listPath ? j[m.listPath] : j) || [];
        var dl = gate && gate.el.querySelector("#srg-vehicles");
        var seen = {};
        for (var i = 0; i < list.length && i < 400; i++) {
          var c = list[i] || {};
          var name = trim(c.make_model || c.description || c.vehicle_type || c.model || c.name || "");
          if (!name || seen[name]) continue;
          seen[name] = 1;
          inventory.push({ name: name, id: String(c.slug || c.id || ""), cond: mode === "new" ? "New" : "Used" });
          if (dl) dl.insertAdjacentHTML("beforeend", '<option value="' + esc(name) + '">' + (mode === "new" ? "New" : "Used") + "</option>");
        }
      }).catch(function () {});
    });
  }

  function topicChanged() {
    var t = val("srg-topic");
    var wantsVehicle = !gate.ctx.item && (t === "New commercial vehicle" || t === "Used commercial vehicle" || t === "Lease a vehicle");
    field("vehicle").hidden = !wantsVehicle;
    if (wantsVehicle) loadInventory();
  }

  function openGate(url, source) {
    if (!gate) gate = build();
    injectFields();
    var wa = parseWa(url);
    var item = vehicleFromText(wa.text) || (source && source.item) || null;
    if (item && source && source.item) {
      for (var k in source.item) if (source.item.hasOwnProperty(k) && !item[k]) item[k] = source.item[k];
    }
    var svc = serviceOf();
    gate.ctx = { url: url, wa: wa, item: item, service: (source && source.service) || svc };
    var r = remembered();
    gate.el.querySelector("#srg-name").value = r.n || "";
    gate.el.querySelector("#srg-phone").value = r.p ? r.p.replace(/^\+65\s?/, "") : "";
    gate.el.querySelector("#srg-vehicle").value = "";
    gate.el.querySelector(".srg-hp").value = "";
    for (var i = 0, bad = gate.el.querySelectorAll(".srg-bad"); i < bad.length; i++) bad[i].classList.remove("srg-bad");

    var box = gate.el.querySelector(".srg-item");
    var topic = gate.el.querySelector("#srg-topic");
    if (item && item.item_name) {
      box.hidden = false;
      box.querySelector("b").textContent = item.item_name;
      box.querySelector("span").textContent = [item.category, item.price].filter(Boolean).join(" · ");
      var img = box.querySelector("img");
      if (item.photo) { img.src = item.photo; img.style.display = ""; } else img.style.display = "none";
      field("topic").hidden = true;
      topic.value = /used/i.test(item.condition || svc) ? "Used commercial vehicle" : "New commercial vehicle";
      gate.ctx.autoMsg = "I am interested in the " + item.item_name + ". Could you share the latest price and availability?";
    } else {
      box.hidden = true;
      field("topic").hidden = false;
      topic.value = TOPIC_BY_SERVICE[gate.ctx.service] || "";
      gate.ctx.autoMsg = "";
    }
    topicChanged();
    gate.el.classList.add("open");
    gate.openedAt = Date.now();
    document.documentElement.style.overflow = "hidden";
    interest({ type: "wa_tap", service: gate.ctx.service, item_id: item ? item.item_id : "", item_name: item ? item.item_name : "",
      item_group: item ? item.item_group || "" : "", condition: item ? item.condition || "" : "" });
    setTimeout(function () {
      var first = gate.el.querySelector("#srg-name");
      if (first.value) first = gate.el.querySelector(gate.el.querySelector("#srg-phone").value ? ".srg-go" : "#srg-phone");
      if (window.innerWidth >= 768) try { first.focus(); } catch (e) {}
    }, 60);
    log("gate open", gate.ctx);
  }

  function close() {
    if (!gate) return;
    gate.el.classList.remove("open");
    document.documentElement.style.overflow = "";
  }

  function withNote(url) {
    var note = trim(API.note);
    API.note = "";
    if (!note) return url;
    var wa = parseWa(url), mark = "\n\nMy comparison:";
    var text = wa.text.indexOf(mark) > -1 ? wa.text.replace(mark, "\n\n" + note + mark) : wa.text + "\n\n" + note;
    return url.split("?")[0] + "?" + (wa.phone && url.indexOf("phone=") > -1 ? "phone=" + wa.phone + "&" : "") + "text=" + encodeURIComponent(text);
  }

  function sendAnon(url, item, service) {
    interest({ type: "wa_tap", service: service || serviceOf(), item_id: item ? item.item_id : "", item_name: item ? item.item_name : "",
      item_group: item ? item.item_group || "" : "", condition: item ? item.condition || "" : "" });
    var wa = parseWa(withNote(url)), info = readSource(wa.text);
    if (item && info.lines.length) info.title = "Vehicle";
    var topic = item ? (/used/i.test(item.condition || service || "") ? "Used commercial vehicle" : "New commercial vehicle") : (TOPIC_BY_SERVICE[service] || "");
    openWhatsApp(waUrl(wa.phone || defaultNumber(), composeText({ enquiry: topic || info.enquiry, info: info }, "")));
    return true;
  }

  function submit() {
    if (!val("srg-name") && !val("srg-phone")) {
      if (gate.el.querySelector(".srg-hp").value) { close(); return; }
      if (Date.now() - gate.openedAt < 900) return;
      var c = gate.ctx;
      close();
      sendAnon(c.url, c.item, c.service);
      return;
    }
    var ok = true;
    var bad = function (name) { field(name).classList.add("srg-bad"); if (ok) { try { field(name).querySelector("input,select,textarea").focus(); } catch (e) {} } ok = false; };
    var name = val("srg-name"), email = "", topic = val("srg-topic"), message = gate.ctx.autoMsg || "";
    var phone = sgMobile(val("srg-phone"));
    if (!validName(name)) bad("name");
    if (!phone) bad("phone");
    if (!gate.ctx.item && !topic) topic = "Something else";
    if (!ok) return;
    if (gate.el.querySelector(".srg-hp").value) { close(); return; }
    if (Date.now() - gate.openedAt < 900) return;
    if (throttled()) {
      field("phone").querySelector(".srg-err").textContent = "Too many enquiries from this device. Please try again in a few minutes.";
      field("phone").classList.add("srg-bad");
      return;
    }
    var ctx = gate.ctx, item = ctx.item;
    var vehicleTyped = val("srg-vehicle");
    if (!item && vehicleTyped) {
      var hit = null;
      for (var i = 0; inventory && i < inventory.length; i++) if (inventory[i].name.toLowerCase() === vehicleTyped.toLowerCase()) hit = inventory[i];
      item = { item_id: hit ? hit.id : "", item_name: hit ? hit.name : vehicleTyped, condition: hit ? hit.cond : "" };
    }
    if (API.note) { ctx.url = withNote(ctx.url); ctx.wa = parseWa(ctx.url); }
    var info = readSource(ctx.wa.text);
    if (item && !info.lines.length) {
      info.lines = [item.item_name].concat(item.category ? ["Category: " + item.category] : [],
        item.price ? ["Price: " + item.price] : [], item.condition ? ["Condition: " + item.condition] : []);
    }
    if (item && info.lines.length) info.title = "Vehicle";
    var svc = ctx.service;
    if (!ctx.item) {
      for (var s in TOPIC_BY_SERVICE) if (TOPIC_BY_SERVICE.hasOwnProperty(s) && TOPIC_BY_SERVICE[s] === topic) { svc = s; break; }
    }
    close();
    complete({
      name: name, phone: phone, email: email, number: ctx.wa.phone || defaultNumber(),
      message: message, info: info, enquiry: topic || info.enquiry,
      label: item ? item.item_name : (topic || "WhatsApp"), topic: ctx.item ? "" : topic, service: svc, item: item
    });
  }

  function sourceFromClick(target) {
    var out = { item: null, service: "" };
    try {
      var card = target.closest && target.closest(".abl-card, .t8-card");
      if (card && window.SR_META_TRACKER && window.SR_META_TRACKER.read) out.item = itemFromMeta(window.SR_META_TRACKER.read(card));
    } catch (e) {}
    return out;
  }

  window.addEventListener("click", function (e) {
    try {
      var t = e.target;
      if (!t || !t.closest) return;
      if (t.closest(".t8-wa, .t8-card")) {
        lastFormOpen = Date.now();
        var s = sourceFromClick(t);
        if (s.item) lastUsedItem = s.item;
        if (t.closest(".t8-wa") && s.item) {
          interest({ type: "wa_tap", service: "Used vehicles", item_id: s.item.item_id, item_name: s.item.item_name,
            item_group: s.item.item_group, condition: s.item.condition });
        }
      }
      if (t.closest("#wa-card .wa-car, #wa-card .wa-menu-btn, #wa-card .wa-link-btn")) lastFormOpen = Date.now();
      var sendBtn = t.closest(".t8-enq-submit, #screen-form .wa-send-btn");
      if (sendBtn) {
        var scope = sendBtn.closest(".t8-enq-form") || document.getElementById("screen-form");
        if (scope && formProblem(scope, !!sendBtn.closest(".t8-enq-form"))) {
          e.preventDefault();
          e.stopPropagation();
          return;
        }
        holdEmptyEmail(scope && scope.querySelector('[id^="t8-enq-email-"], #wa_email'));
      }
      var a = t.closest("a[href]");
      if (!a) return;
      var href = a.getAttribute("href") || "";
      if (!WA_RE.test(href) || !parseWa(a.href).phone) return;
      e.preventDefault();
      openGate(a.href, sourceFromClick(t));
    } catch (err) {}
  }, true);

  function wrapOpen() {
    if (window.open && window.open.__srGate) return;
    nativeChainOpen = window.open;
    var wrapped = function (u) {
      try {
        if (!passing && typeof u === "string" && WA_RE.test(u) && parseWa(u).phone) {
          if (handleUsedSheet(u)) return null;
          if (handleWidget(u)) { if (window.ABLWA) window.ABLWA._skipWaOpen = false; return null; }
          if (window.ABLWA) {
            window.ABLWA._skipWaOpen = false;
            if (window.ABLWA.track) {
              var x = parseWa(u);
              window.ABLWA.track({ event: "wa_click", source: "window.open", name: "", email: "", website: "", wa_number: x.phone,
                message: x.text || "(opened WhatsApp)" });
            }
          }
          openGate(u, null);
          return null;
        }
      } catch (err) {}
      return nativeChainOpen.apply(window, arguments);
    };
    wrapped.__srGate = true;
    window.open = wrapped;
  }
  wrapOpen();

  function ready() { injectFields(); }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", ready);
  else ready();
  window.addEventListener("load", injectFields);

  API.open = function (url) { openGate(url || waUrl(defaultNumber(), "Hello " + BRAND + " 👋"), null); };
  API.lib = { refCode: refCode, sgMobile: sgMobile, validName: validName, validEmail: validEmail, vehicleFromText: vehicleFromText,
    serviceOf: serviceOf, readSource: readSource, composeText: composeText, budgetText: budgetText, flush: flush };
})();
